export const neverReachedFor = (arg: never): never => {
    throw Error(`Should never be called. Was called with ${arg}`);
};
